import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

// Components
import { ErrorComponent } from './Common/Components/Error/error.component';
import { LoaderComponent } from './Common/Components/Loader/loader.component';
import { FooterComponent } from './Common/Components/Footer/footer.component';
import { HeaderComponent } from './Common/Components/Header/header.component';

// TOASTER
import { ToasterModule } from 'angular2-toaster';

// CORE
import {
  ErrorLogService,
  CoreModule, StringService, ToastrService
} from './core';

// Services
import { AppService } from './app.service';
import { PeticionCoordenadasGuard } from '../app/Home/PeticionCoordenadas/peticionCoordenadas-guard.service';
import { ContrasenaOlvidadaGuard } from '../app/Home/ContrasenaOlvidada/contrasenaOlvidada-guard.service';
import { WinAuthInterceptor } from './Common/Interceptor/WinAuthInterceptor';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { MatDialogModule } from '@angular/material';

registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
    LoaderComponent,
    FooterComponent,
    HeaderComponent
  ],
  imports: [
    ToasterModule.forRoot(),
    CoreModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatDialogModule
  ],
  providers: [
    { 
      provide: LOCALE_ID,
      useValue: 'es' 
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WinAuthInterceptor,
      multi: true
    }, StringService, ErrorLogService, ToastrService, AppService, PeticionCoordenadasGuard, ContrasenaOlvidadaGuard],
  bootstrap: [AppComponent],
  entryComponents: [
    LoaderComponent
]
})
export class AppModule {

  constructor() {
 }

 }

